<div layout-vertical gap-small-xx padding-bottom-small-xx>
  <div class="row">
    <rt-heading>
      {{ offerData().title }}
    </rt-heading>
  </div>
  @if (kind() === 'job') {
    <ng-container [ngTemplateOutlet]="status" />
    <ng-container [ngTemplateOutlet]="department" />
    <ng-container [ngTemplateOutlet]="dateCreated" />
    <ng-container [ngTemplateOutlet]="recruiter" />
    <ng-container [ngTemplateOutlet]="hiringManager" />
    <ng-container [ngTemplateOutlet]="workModel" />
  }

  @if (kind() === 'talent_pool') {
    <ng-container [ngTemplateOutlet]="department" />
    <ng-container [ngTemplateOutlet]="dateCreated" />
    <ng-container [ngTemplateOutlet]="description" />
  }
</div>
<ng-template #status>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.common.status' | translate }}</div>
    <div>
      <rt-offer-status-indicator [offerStatus]="offerData()" />
      {{ offersStatuses[offerData().status] }}
    </div>
  </div>
</ng-template>
<ng-template #department>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.offers.group_by.department' | translate }}</div>
    <div>
      @if (offerData().department) {
        {{ offerData().department }}
      } @else {
        —
      }
    </div>
  </div>
</ng-template>
<ng-template #description>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.common.description' | translate }}</div>
    <div>
      @if (talentPool()!.description!) {
        <div class="description">
          {{ talentPool()!.description! | rtRemoveHTMLTags }}
        </div>
      } @else {
        —
      }
    </div>
  </div>
</ng-template>
<ng-template #dateCreated>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.offers.table.create_date' | translate }}</div>
    <div>
      {{ offerData().createdAt | date: 'dd MMM y' }}
    </div>
  </div>
</ng-template>
<ng-template #recruiter>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.offers.group_by.recruiter' | translate }}</div>
    <div layout-horizontal layout-align-items-center gap-small-xx>
      @if (job().recruiter; as offerRecruiter) {
        <rt-avatar
          [type]="offerRecruiter.hasAvatar ? 'image' : 'initials'"
          [imageSrc]="offerRecruiter.photoThumbUrl"
          [initials]="offerRecruiter.initials"
          size="small-x"
        />
        {{ offerRecruiter.firstName }} {{ offerRecruiter.lastName }}
      } @else {
        —
      }
    </div>
  </div>
</ng-template>
<ng-template #hiringManager>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.offers.group_by.hiring_manager' | translate }}</div>
    <div layout-horizontal layout-align-items-center gap-small-xx>
      @if (job().hiringManager; as hiringManager) {
        <rt-avatar
          [type]="hiringManager.hasAvatar ? 'image' : 'initials'"
          [imageSrc]="hiringManager.photoThumbUrl"
          [initials]="hiringManager.initials"
          size="small-x"
        />
        {{ hiringManager.firstName }} {{ hiringManager.lastName }}
      } @else {
        —
      }
    </div>
  </div>
</ng-template>
<ng-template #workModel>
  <div class="row">
    <div text-weight-semi-bold>{{ 'app.offers.table.work_model' | translate }}</div>
    <div>
      {{ workModelCopy() }}
    </div>
  </div>
</ng-template>
